<template>
  <AnalyticsWidget
    title="Accounts Receivables Overview"
    :subTitle="subTitle"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight"
  >
    <div class="p-2">
      <LoadingPanel :loading="loading" />
      <AnalyticsDashboardValueRow v-if="!loading">
        <div class="col">
          <AnalyticsDashboardValue
            title="Total Outstanding"
            :value="trialBalanceData.totalOutstanding"
            helpTip="Total invoice amount owing minus available payments/credits"
            :viewMoreLink="hasContactFilter ? null : '/analytics/reports/accounts/agedtrialbalance#tab-agedbalance'"
            highlight>
            {{formatCurrencyAccounts(trialBalanceData.totalOutstanding)}}
            <template v-slot:info>{{valueInfoDescription(trialBalanceData.totalInvoiceTotalCount, 'Invoice')}}</template>
          </AnalyticsDashboardValue>
        </div>
        <div class="col">
          <AnalyticsDashboardValue title="Current" :value="trialBalanceData.totalOutstandingCurrent" helpTip="Total invoice amount (not overdue) owing minus available payments/credits">
            {{formatCurrencyAccounts(trialBalanceData.totalOutstandingCurrent)}}
            <template v-slot:info>{{valueInfoDescription(trialBalanceData.totalInvoiceCurrentCount, 'Invoice')}}</template>
          </AnalyticsDashboardValue>
        </div>
        <div class="col">
          <AnalyticsDashboardValue title="Overdue 0-30 days" :value="trialBalanceData.totalInvoiceDue0to30" helpTip="Total invoice amount overdue by less than 30 days">
            {{formatCurrencyAccounts(trialBalanceData.totalInvoiceDue0to30)}}
            <template v-slot:info>{{valueInfoDescription(trialBalanceData.totalInvoiceDue0to30Count, 'Invoice')}}</template>
          </AnalyticsDashboardValue>
        </div>
        <div class="col">
          <AnalyticsDashboardValue title="Overdue 30-60 days" :value="trialBalanceData.totalInvoiceDue30to60" helpTip="Total invoice amount overdue by 30-60 days">
            {{formatCurrencyAccounts(trialBalanceData.totalInvoiceDue30to60)}}
            <template v-slot:info>{{valueInfoDescription(trialBalanceData.totalInvoiceDue30to60Count, 'Invoice')}}</template>
          </AnalyticsDashboardValue>
        </div>
      </AnalyticsDashboardValueRow>
      <AnalyticsDashboardValueRow v-if="!loading">
        <div class="col">
          <AnalyticsDashboardValue title="Overdue 60-90 days" :value="trialBalanceData.totalInvoiceDue60to90" helpTip="Total invoice amount overdue by 60-90 days">
            {{formatCurrencyAccounts(trialBalanceData.totalInvoiceDue60to90)}}
            <template v-slot:info>{{valueInfoDescription(trialBalanceData.totalInvoiceDue60to90Count, 'Invoice')}}</template>
          </AnalyticsDashboardValue>
        </div>
        <div class="col">
          <AnalyticsDashboardValue title="Overdue 90+ days" :value="trialBalanceData.totalInvoiceDue90Plus" helpTip="Total invoice amount overdue more than 90 days">
            {{formatCurrencyAccounts(trialBalanceData.totalInvoiceDue90Plus)}}
            <template v-slot:info>{{valueInfoDescription(trialBalanceData.totalInvoiceDue90PlusCount, 'Invoice')}}</template>
          </AnalyticsDashboardValue>
        </div>
        <div class="col">
          <AnalyticsDashboardValue title="Available Credit Notes" :value="trialBalanceData.totalCreditNoteAvailable" helpTip="Total credit notes amount not allocated to invoices">
            {{formatCurrencyAccounts(trialBalanceData.totalCreditNoteAvailable)}}
            <template v-slot:info>{{valueInfoDescription(trialBalanceData.totalCreditNoteAvailableCount, 'Credit Note')}}</template>
          </AnalyticsDashboardValue>
        </div>
        <div class="col">
          <AnalyticsDashboardValue title="Overpayments" :value="trialBalanceData.totalOverpaymentAvailable" helpTip="Total overpayment amount not allocated to invoices">
            {{formatCurrencyAccounts(trialBalanceData.totalOverpaymentAvailable)}}
            <template v-slot:info>{{valueInfoDescription(trialBalanceData.totalOverpaymentAvailableCount, 'Overpayment')}}</template>
          </AnalyticsDashboardValue>
        </div>
      </AnalyticsDashboardValueRow>
    </div>
  </AnalyticsWidget>
</template>


<script>
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'
import AnalyticsDashboardValueRow from '@/modules/intelligence/components/analyticsDashboardValueRow'

export default {
  name: 'AccountsReceivableSummaryWidget',
  components: {
    AnalyticsWidget,
    AnalyticsDashboardValue,
    AnalyticsDashboardValueRow
  },
  props: {
    contactId: Number,
    gridWidth: Number,
    gridHeight: Number
  },
  data() {
    return {
      loading: false,
      trialBalanceData: {}
    }
  },
  computed: {
    hasContactFilter() {
      return this.contactId != null
    },
    subTitle() {
      if(this.contactId)
        return 'Breakdown of outstanding invoices for the contact'
      return 'Breakdown of outstanding invoices for account based contacts'
    }
  },
  mounted() {
    this.loading = true
    this.requestData()

    this.subscribeEndpoint('/accounts/invoices', () => {
      this.requestData()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/accounts/invoices')
  },
  watch: {
    contactId: function() {
      this.requestData()
    }
  },
  methods: {
    requestData() {
      var dataFilter = {
        contactId: this.contactId
      }

      this.$apiService.analyticsService.getAccountsAgedTrialBalance(dataFilter)
      .then(response => {
        this.trialBalanceData = response.data
      })
      .finally(() => {
        this.loading = false
      })
    },
    valueInfoDescription(count, suffix) {
      return `In ${count} ${suffix}` + this.displayCountPlural(count)
    }
  }
}
</script>